<div class="modal-header">
  <button type="button" class="close close-lg pull-right" aria-label="Close"
          (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h1 class="modal-title">Select a Shared Number</h1>
</div>
<div class="modal-body">
  <div>
    <table border="2" bordercolor="white" class="table table-condensed table-hover">
      <tbody>
      <tr>
          <th class="col-md-2" style="width: 150px">Number</th>
          <th class="col-md-2" style="width: 150px">Details</th>
        <th class="col-md-1" style="width: 150px">Country</th>
      </tr>
      <tr *ngFor="let sharedNumber of (sharedNumbers$ | async )" (click)="selectSharedNumber(sharedNumber)">
        <td>#{{sharedNumber.phoneNumber}}</td>
        <td>{{sharedNumber.description}}</td>
        <td>{{sharedNumber.country}}</td>
      </tr>
      </tbody>
    </table>

  </div>
</div>
